import { createFileRoute } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/declaracoes')({
  component: DeclaracoesPage,
});

function DeclaracoesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Anual"
      title="Declarações"
      description="Declarações obrigatórias do exercício (CND, RAIS, DIRF…)."
      icon={ClipboardList}
      bullets={[
        'Certidões negativas (CND federal, estadual, municipal)',
        'RAIS e DIRF do ano-base',
        'Comprovantes de regularidade',
      ]}
      etaLabel="próxima fase"
    />
  );
}
